var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$l10n.__(
              "Consulter l’ensemble des paramètres renseignés lors de votre import"
            )
          ) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "list-settings-used" },
      [
        !_vm.isImportV2
          ? _vm._l(_vm.importOptions.identifiers, function(
              identifierOptions,
              identifier
            ) {
              return _c("p", { key: identifier, staticClass: "line-setting" }, [
                _c(
                  "span",
                  {
                    staticClass: "title typographies-paragraph-medium-semibold"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(identifierOptions.title) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.getLabelIdentifier(
                            identifier.toString(),
                            _vm.importDetail._embed.metadata.identifiers[
                              identifier
                            ]
                          )
                        ) +
                        "\n                "
                    )
                  ]
                )
              ])
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldDisplayCreationFieldsOptions
          ? _c("p", { staticClass: "line-setting" }, [
              _c(
                "span",
                { staticClass: "title typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getTitleSetting("insert_new_records")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getLabelSetting(
                          "insert_new_records",
                          _vm.importDetail._embed.metadata.insert_new_records
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldDisplayUpdateFieldsOptions
          ? _c("p", { staticClass: "line-setting" }, [
              _c(
                "span",
                { staticClass: "title typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getTitleSetting("update_existing_records")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getLabelSetting(
                          "update_existing_records",
                          _vm.importDetail._embed.metadata
                            .update_existing_records
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "line-setting" }, [
          _c(
            "span",
            { staticClass: "title typographies-paragraph-medium-semibold" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.getTitleSetting("update_empty_fields")) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.getLabelSetting(
                    "update_empty_fields",
                    _vm.importDetail._embed.metadata.update_empty_fields
                  )
                ) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _vm.shouldDisplayUpdateFieldsOptions
          ? _c("p", { staticClass: "line-setting" }, [
              _c(
                "span",
                { staticClass: "title typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getTitleSetting("overwrite_tags")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getLabelSetting(
                          "overwrite_tags",
                          _vm.importDetail._embed.metadata.overwrite_tags
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldDisplayCustomFieldsOptions
          ? _c("p", { staticClass: "line-setting" }, [
              _c(
                "span",
                { staticClass: "title typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Si un champ personnalisé obligatoire de mon fichier est vide"
                        )
                      ) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getLabelSetting(
                          "dismiss_required_custom_fields",
                          _vm.importDetail._embed.metadata
                            .dismiss_required_custom_fields
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldDisplayCustomFieldsOptions
          ? _c("p", { staticClass: "line-setting" }, [
              _c(
                "span",
                { staticClass: "title typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Si une cellule de champ personnalisé de mon fichier est vide"
                        )
                      ) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getLabelSetting(
                          "use_default_values_for_empty_custom_fields",
                          _vm.importDetail._embed.metadata
                            .use_default_values_for_empty_custom_fields
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldDisplayCustomFieldsOptions
          ? _c("p", { staticClass: "line-setting" }, [
              _c(
                "span",
                { staticClass: "title typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Si une option de liste de mon fichier n'existe pas dans Sellsy"
                        )
                      ) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getLabelSetting(
                          "insert_new_custom_fields_enum_values",
                          _vm.importDetail._embed.metadata
                            .insert_new_custom_fields_enum_values
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }